/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CustomerCommandDto } from '../model/customerCommandDto';
// @ts-ignore
import { CustomerNewRemoteCommandDto } from '../model/customerNewRemoteCommandDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CommandsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param customerCommandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addOfflineCommand(customerCommandDto: CustomerCommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerCommandDto>;
    public addOfflineCommand(customerCommandDto: CustomerCommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerCommandDto>>;
    public addOfflineCommand(customerCommandDto: CustomerCommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerCommandDto>>;
    public addOfflineCommand(customerCommandDto: CustomerCommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerCommandDto === null || customerCommandDto === undefined) {
            throw new Error('Required parameter customerCommandDto was null or undefined when calling addOfflineCommand.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/offline`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerCommandDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: customerCommandDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param customerNewRemoteCommandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerCommandDto>;
    public addRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerCommandDto>>;
    public addRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerCommandDto>>;
    public addRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerNewRemoteCommandDto === null || customerNewRemoteCommandDto === undefined) {
            throw new Error('Required parameter customerNewRemoteCommandDto was null or undefined when calling addRemoteCommand.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/remote`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerCommandDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: customerNewRemoteCommandDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelRemoteCommand(body: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerCommandDto>;
    public cancelRemoteCommand(body: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerCommandDto>>;
    public cancelRemoteCommand(body: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerCommandDto>>;
    public cancelRemoteCommand(body: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling cancelRemoteCommand.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/remote/cancel`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerCommandDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param page 
     * @param count 
     * @param orderBy 
     * @param orderDirection 
     * @param deviceClassWithOwnIdPool 
     * @param requestBody 
     * @param commandStateFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCommands(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CustomerCommandDto>>;
    public getCommands(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CustomerCommandDto>>>;
    public getCommands(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CustomerCommandDto>>>;
    public getCommands(page: number, count: number, orderBy: string, orderDirection: string, deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getCommands.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling getCommands.');
        }
        if (orderBy === null || orderBy === undefined) {
            throw new Error('Required parameter orderBy was null or undefined when calling getCommands.');
        }
        if (orderDirection === null || orderDirection === undefined) {
            throw new Error('Required parameter orderDirection was null or undefined when calling getCommands.');
        }
        if (deviceClassWithOwnIdPool === null || deviceClassWithOwnIdPool === undefined) {
            throw new Error('Required parameter deviceClassWithOwnIdPool was null or undefined when calling getCommands.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling getCommands.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderBy, 'orderBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderDirection, 'orderDirection');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceClassWithOwnIdPool, 'deviceClassWithOwnIdPool');
        if (commandStateFilter) {
            commandStateFilter.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'commandStateFilter');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CustomerCommandDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param deviceClassWithOwnIdPool 
     * @param requestBody 
     * @param commandStateFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCommandsCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getCommandsCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getCommandsCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getCommandsCount(deviceClassWithOwnIdPool: 'COLLAR' | 'EXTERNAL_SENSOR' | 'CAMERA' | 'TT4_SENSOR' | 'CONFIGURATION_DEVICE' | 'DROP_OFF' | 'TRAP_TRANSMITTER' | 'DATA_LOGGER', requestBody: Array<number>, commandStateFilter?: Array<'CREATED' | 'SENT_TO_SERVER' | 'SENT_TO_DEVICE' | 'FAILED_SENDING_TO_SERVER' | 'FAILED_SENDING_TO_DEVICE' | 'FAILED_ON_DEVICE' | 'FAILED_UNSPECIFIED' | 'ACKNOWLEDGED' | 'CANCELED' | 'FAILED_EXPIRED'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deviceClassWithOwnIdPool === null || deviceClassWithOwnIdPool === undefined) {
            throw new Error('Required parameter deviceClassWithOwnIdPool was null or undefined when calling getCommandsCount.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling getCommandsCount.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceClassWithOwnIdPool, 'deviceClassWithOwnIdPool');
        if (commandStateFilter) {
            commandStateFilter.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'commandStateFilter');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/count`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param customerNewRemoteCommandDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public validateRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public validateRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public validateRemoteCommand(customerNewRemoteCommandDto: CustomerNewRemoteCommandDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerNewRemoteCommandDto === null || customerNewRemoteCommandDto === undefined) {
            throw new Error('Required parameter customerNewRemoteCommandDto was null or undefined when calling validateRemoteCommand.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/commands/remote/validate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<number>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: customerNewRemoteCommandDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
